import { memo, type CSSProperties } from 'react';

import SweepCoinPile from '../../assets/coin/sc_pile.png';
import sweepCoinPileWebp from '../../assets/coin/sc_pile.webp';
import sweepCoinPng from '../../assets/sweep_coin.png';
import sweepCoinWebp from '../../assets/sweep_coin_2x.webp';

export const SweepCoin = memo(
  ({
    className,
    style,
    alt,
    isPile,
  }: {
    className?: string;
    style?: CSSProperties;
    alt?: string;
    isPile?: boolean;
  }) => {
    return (
      <picture className={className} style={{ display: 'flex', ...style }}>
        <source srcSet={isPile ? sweepCoinPileWebp : sweepCoinWebp} type="image/webp" />
        <source srcSet={isPile ? SweepCoinPile : sweepCoinPng} type="image/png" />
        <img alt={alt || 'Sweep Coin'} src={isPile ? SweepCoinPile : sweepCoinPng} />
      </picture>
    );
  },
);

SweepCoin.displayName = 'SweepCoin';
